import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../../commons/services/split-service.service";

export class ServiceTimeRequestsService {
  constructor(private $pricePlan, private PricePlanAPI, private triTheming, private pricePlanConstant, private $stateParams, private splitService: SplitService) {
  }

  getEventColorScheme(isSpecialDay, state) {
    const colorScheme = this.pricePlanConstant.serviceTime.colorScheme[isSpecialDay ? 'specialDay' : 'serviceTime'],
      palette = this.triTheming.palettes[colorScheme[state]],
      isParent = !_.isEqual(this.pricePlanConstant.serviceTime.events.isParent.indexOf(state), -1),
      hue = this.pricePlanConstant.serviceTime.colorScheme.hue[isParent ? 'inherit' : 'override'];

    return {
      backgroundColor: this.triTheming.rgba(palette[hue].value),
      borderColor: this.triTheming.rgba(palette[hue].value),
      textColor: this.triTheming.rgba(palette[hue].contrast),
      palette: palette
    };
  }

  getServiceTimeAndSpecialDaysData(pricePlanId, params) {
    const getUrl = this.PricePlanAPI.actions.getServiceTimeAndSpecialDaysData;

    if (!_.isUndefined(this.$stateParams.id)) {
      _.set(params, 'accountId', this.$stateParams.id);
    }

    return this.$$call(getUrl, {...params, zoneId: this.splitService.getTimeZone()}, null, {pricePlanId: pricePlanId});
  }

  updateCreateServiceTime(pricePlanId, serviceTime, params?) {
    const api = this.PricePlanAPI.actions.updateCreateServiceTime;
    serviceTime = _.isArray(serviceTime) ? serviceTime : [serviceTime]
    return this.$$call(api, {...params, zoneId: this.splitService.getTimeZone()}, serviceTime, {pricePlanId: pricePlanId});
  }

  updateCreateSpecialDay(pricePlanId?, specialDay?, params?) {
    const api = this.PricePlanAPI.actions.updateCreateSpecialDay;
    return this.$$call(api, {...params, zoneId: this.splitService.getTimeZone()}, [specialDay], {pricePlanId: pricePlanId});
  }


  getSpecialDays(pricePlanId, params) {
    const getUrl = this.PricePlanAPI.actions.getSpecialDays;
    return this.$$call(getUrl, {...params, zoneId: this.splitService.getTimeZone()}, null, {pricePlanId: pricePlanId});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(apiCall, params, data, options) {
    return this.$pricePlan().$call(apiCall, params, data, options);
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .service('serviceTimeRequestsService', ServiceTimeRequestsService);
